import { useState, useEffect } from 'react'
import ShowClientTab from '../../tabs/ShowClientTab'
import { GlobalConsumer, GlobalProvider } from '../../context/GlobalContext'
import UserHeader from '../../components/UserHeader'

const ClientDetailTab = ({
  clientData,
  isFetching,
  isEditClient,
  editForm,
  successCreateForNewClient
}) => {
  const [state, setState] = useState({
    alertState: 'alert alert-success',
    editGlobal: false
  })

  useEffect(() => {
    setState((prevState) => ({ ...prevState, editGlobal: editForm }))
  }, [editForm])

  const hiddenAlert = () => {
    setState((prevState) => ({
      ...prevState,
      alertState: 'alert alert-success hidden'
    }))
  }

  return (
    <GlobalProvider stateEdit={state.editGlobal} globalEdit={isEditClient} location="detalles">
      <GlobalConsumer>
        {({ globalEdit }) => (
          <>
            <div>
              <UserHeader isFormEditing={globalEdit} />
            </div>

            <>
              {successCreateForNewClient && (
                <div className={state.alertState} role="alert">
                  <button
                    type="button"
                    className="btn-close"
                    onClick={hiddenAlert}
                    aria-label="Close"
                  ></button>
                  <strong className="success-message">
                    El cliente nuevo fue creado exitosamente.
                  </strong>
                </div>
              )}

              <div className="main-show-header">
                <h2>{`Cliente: ${clientData?.db_ref} - ${clientData?.customer_name_db_ref}`}</h2>
              </div>

              {!isFetching && (
                <div className="index-table">
                  <div className="show-area">
                    <ShowClientTab />
                  </div>
                </div>
              )}
            </>
          </>
        )}
      </GlobalConsumer>
    </GlobalProvider>
  )
}

export default ClientDetailTab
